import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: 'Clientas que dicen "te aviso"',
  desc: 'El mensaje sale, la consulta muere y el hueco queda vacío sin que entiendas por qué.'
}, {
  title: 'Cancelaciones a último momento que te destrozan el día',
  desc: 'Te quedás sin ingreso, con el tiempo muerto y sin plan B para cubrirlo.'
}, {
  title: 'Siempre los mismos precios porque no sabés cómo subirlos',
  desc: 'La inflación te come la ganancia y seguís trabajando igual que hace un año.'
}, {
  title: 'Trabajás 10 horas y el resultado no aparece',
  desc: 'Facturás pero no ves progreso. Caja y bolsillo mezclados, sin claridad financiera.'
}, {
  title: 'Dependés del algoritmo de Instagram para que te vean',
  desc: 'Un día te escriben diez, el otro nadie. Tu negocio depende de la suerte.'
}, {
  title: 'Fin de semana agotada, el lunes volvés a empezar el mismo ciclo',
  desc: 'Sos esclava de tu camilla, no dueña de tu tiempo ni de tu negocio.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="bg-ink-2 border-y border-white/5" data-id="element-104" data-mp="1yykezhme9g2t">
      <div className="mx-auto max-w-4xl px-5 py-20 pt-[5px] pb-[33px]" data-id="element-105" data-mp="1u12coa2vtz3s">
        <h2 className="text-center font-display font-black text-white sm:text-4xl text-[28px]" data-id="element-106" data-mp="27rxfb4msfjyx">
          ¿Cuántos turnos más vas a perder así?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-107" data-mp="23trf6fggg2mz">
          Sos lashista. Amás aplicar pestañas. Pero nadie te dijo que ibas a pasar los días
          respondiendo mensajes que no cierran, sufriendo cancelaciones a último momento y llegando
          a fin de mes sin saber dónde está la plata.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-rose-soft" data-id="element-108" data-mp="1k2mp2h32d7z1">
          No es falta de talento. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-109" data-mp="2vhje3qz8zx6e">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-110" data-mp="1t5ohct91jzv7" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose/15 text-rose" data-id="element-111" data-mp="273mrfmgbxa4w">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-112" data-mp="1ackmj4k37gz0" />
              </span>
              <div data-id="element-113" data-mp="1egsa2yet6qvn">
                <h3 className="text-sm font-bold text-white" data-id="element-114" data-mp="1ee62iyrx4bdf">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-115" data-mp="1jdskflioyfsk">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-116" data-mp="qqocb7oaxlck">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-117" data-mp="qpwqgokib1zh">
            ¿Y si este fuera el último lunes que empezás con huecos en la agenda?
          </p>
          <p className="mt-3 text-lg font-semibold text-rose-soft" data-id="element-118" data-mp="o6i58r4e5ers">
            La próxima semana puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}